export default "__VITE_ASSET__DORSR3u$__"